import {
  DUPLICATE_RECORD_ERROR_TEMPLATE,
  formatErrorMessageTemplate,
} from '@app/shared/validation';
import { customYup as Yup } from '@app/vendor/customYup';
import { marginSystemFormSchema } from '../SystemConfigurationDialog/components/MarginSystemFormDialog/components/MarginSystemForm/marginSystemFormSchema';

export const MARGIN_SYSTEM_TABLE_DUPLICATE_NAME_ERROR = formatErrorMessageTemplate(
  DUPLICATE_RECORD_ERROR_TEMPLATE,
  [{ pattern: '{name}', value: 'Margin System name' }]
);

export const marginSystemTableSchema = Yup.array().of(
  marginSystemFormSchema.uniqueProperty(
    'name',
    MARGIN_SYSTEM_TABLE_DUPLICATE_NAME_ERROR
  )
);
